import { VariantAttributeValue } from 'types/models/VariantAttributeValue';

const checkIfAttributeValueMatch = (
  currentVariantAttribute?: VariantAttributeValue,
  variantAttribute?: VariantAttributeValue
): boolean => {
  const noneValueMatch = currentVariantAttribute?.isNone && currentVariantAttribute.isNone === variantAttribute?.isNone;
  const simpleValueMatch =
    !!currentVariantAttribute?.attributes &&
    !!variantAttribute?.attributes &&
    currentVariantAttribute.attributes?.id === variantAttribute?.attributes?.id;
  const variantMatch =
    !!currentVariantAttribute?.targetVariant &&
    !!variantAttribute?.targetVariant &&
    currentVariantAttribute.targetVariant?.id === variantAttribute?.targetVariant?.id;
  return noneValueMatch || simpleValueMatch || variantMatch;
};

export default checkIfAttributeValueMatch;
